import { createSelector } from 'reselect'
import { RootState } from 'redux/store'

const selectUserAccessRoles = createSelector(
  (state: RootState) => state.user.accessRoles,
  (roles: string[]) => roles
)

export default selectUserAccessRoles
